
// 复制文本
 export function copyText(text){
     if (navigator.clipboard) {
         navigator.clipboard.writeText(text.trim())
     } else {
         const textArea = document.createElement('textArea')
         textArea.value = text.trim()
         textArea.style.width = 0
         textArea.style.position = 'fixed'
         textArea.style.left = '-999px'
         textArea.style.top = '10px'
         textArea.setAttribute('readonly', 'readonly')
         document.body.appendChild(textArea)
         textArea.select()
         document.execCommand('copy')
         document.body.removeChild(textArea)
     }
 }
export const keyboardKeys = [
    // 功能键
    'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12',

    // 控制键
    'Ctrl', 'Alt', 'Shift', 'Esc',

    // 导航键
    'Up Arrow', 'Down Arrow', 'Left Arrow', 'Right Arrow', 'Home', 'End',
    'Page Up', 'Page Down', 'Insert', 'Delete',

    // 特殊字符键
    'Tab', 'Caps Lock', 'Backspace', 'Enter', 'Space',

    // 数字键盘（若存在）
    'Num Lock', '/', '*', '-', '+', '.',

    // 操作系统特定键
    'Windows Key', 'Command Key', // 在 Mac 上

    // 其他
    'Print Screen', 'Scroll Lock', 'Pause/Break'
];